var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"1px","height":"1px","border":"0"},attrs:{"src":_vm.getSource(),"frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }